import { IndexPostsScreen, IndexPostsScreenProps } from 'shared/screens/blog/index-posts';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';

export default function Blog(props: IndexPostsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('blog.index_posts.title')).setDescription(t('blog.index_posts.description'))
      }
    >
      <IndexPostsScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(IndexPostsScreen.pageBuilder);
